export default __webpack_public_path__ + "static/media/ios-depth-chart.f6ab0db6.png";